import React from 'react';
import Select from 'react-select';

const CustomSelect = ({
  options,                // Array of options for the select dropdown
  isMulti = false,        // Toggle for multi-select (default: single-select)
  placeholder = 'Select...',  // Placeholder text
  value,                  // Selected value(s)
  onChange,               // Function to handle the change
  label = '',             // Optional label for the select component
  className = '',         // Optional custom class for styling
  isSearchable = true     // Whether the select is searchable
}) => {
  // Handle Change
  const handleChange = (selectedOption) => {
    onChange(isMulti ? selectedOption : selectedOption ? selectedOption.value : null);
  };

  return (
    <div className={`custom-select-wrapper ${className}`}>
      {label && <label className="block text-gray-700 font-medium mb-2">{label}</label>}
      
      <Select
        isMulti={isMulti}                // Multi-select or single-select mode
        options={options}                // Options passed from props
        value={isMulti ? value : options.find(option => option.value === value)} // Set selected value
        onChange={handleChange}          // Handle the selection change
        placeholder={placeholder}        // Placeholder text
        isSearchable={isSearchable}      // Searchable dropdown
        classNamePrefix="custom-select"  // Custom class for styling
      />
    </div>
  );
};

export default CustomSelect;
